import { getCurrentEnv, getFlowProps, getOrigin } from '../utils/utils';
import { apiAttributes, EXP_API_V2 } from '../constants/apiAttributes';
import { getI90ApiDetails } from '../utils/apiRouteUtils';
import { experienceIds } from '../constants/expIds';

export const XROUTEHDR = {
  gke: 'PHARMACY-GKE',
  rke: 'PHARMACY-RKE',
  gkeAndRke: 'account-gke-rke'
};
export const X_ROUTE_HEADER = 'x-route';
export const RETAIL_PROFILE_ID_TYPE = 'RETAIL_PROFILE_ID_TYPE';

const isLocal = process.env.ENV === 'local';
const URlPREFIX = !isLocal ? '/account-lookup' : '';

export class CVSData {
  // verify if users access token is valid and users profile is not locked
  static checkUsersAccount = async () => {
    try {
      const [isProfileLocked, introspect] = await Promise.all([this.isProfileLocked(), this.introspect()]);
      return {
        isProfileLocked,
        introspect
      };
    } catch (error) {
      return error;
    }
  };

  // verify if users access token is valid
  static introspect = async () => {
    const url = URlPREFIX + '/api/introspect';

    try {
      const res = await fetch(url, {
        method: 'GET'
      });
      return await res.json();
    } catch (error) {
      return error;
    }
  };

  // verify if users account is not locked
  static isProfileLocked = async () => {
    const url = URlPREFIX + '/api/isProfileLocked';
    let lockType = 'cg';
    const flow = sessionStorage.getItem('lookupFlow');
    const flProps = getFlowProps(flow);
    lockType = flProps?.source;
    const isProfileLockedReq = {
      lt: lockType
    };

    try {
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          data: isProfileLockedReq
        })
      });
      return await res.json();
    } catch (error) {
      return error;
    }
  };

  static getICEHeader = (iceProps: any) => ({
    apiKey: iceProps?.apiKey,
    appName: 'ICE_WEB',
    channelName: 'WEB',
    deviceToken: '7777',
    deviceType: 'DESKTOP',
    lineOfBusiness: 'ICE',
    responseFormat: 'JSON',
    securityType: 'tokenId',
    source: 'ICE_WEB',
    type: 'cn-micro-rxtieauthapp',
    idType: 'CVS_ONS_TOKEN'
  });

  // add and authorize caregiver via Call Center Rep
  static addAndAuthorize = async (rxToken): Promise<any> => {
    try {
      const env = getCurrentEnv();
      const apiProps = apiAttributes.find((en) => {
        return en.envName == env;
      });
      const profileApiProps = apiProps?.addAndAuthorizeCaregivee;
      const subDomain = profileApiProps?.url;
      const url = `${apiProps?.urlPrefix}${subDomain}`;
      const body = {
        data: {
          id: '$id',
          idType: RETAIL_PROFILE_ID_TYPE,
          manageMemberRequest: {
            rxToken,
            recId: btoa(rxToken),
            actorCode: 'CSR',
            source: 'RETAIL',
            flowname: 'caregiving'
          }
        }
      };
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'content-type': 'application/json',
          'accept': 'application/json',
          'x-api-key': profileApiProps!.apikey,
          'x-experienceId': profileApiProps?.experienceId,
          'x-clientId': profileApiProps!.clientId,
          [X_ROUTE_HEADER]: XROUTEHDR.gkeAndRke
        }
      });

      return await res.json();
    } catch (err) {
      console.log(err);
      return err;
    }
  };
  static profileLookup = async (cookies?: string): Promise<any> => {
    try {
      const url = URlPREFIX + '/api/profileLookup';
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'x-route': XROUTEHDR.gkeAndRke
        }
      });

      const response = await res.json();
      return response;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  static logout = (redirect = true): Promise<any> => {
    try {
      const hostname = getOrigin();
      const loginUrl = `${hostname}/account-login`;
      sessionStorage.removeItem('lookupId');
      const apiDetails = getI90ApiDetails('logout');
      const logoutPayload = {
        data: {
          input: {
            soft: false,
            tokens: [
              {
                name: 'iceToken',
                value: 'iceTokenValue'
              }
            ]
          }
        }
      };
      const expId = experienceIds['logout'];
      const url = `${EXP_API_V2}/${expId}`;
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(logoutPayload),
        headers: apiDetails.headers
      }).then((res) => {
        res.json();
        redirect && window.location.assign(loginUrl);
      });
    } catch (err) {
      console.error(err);
    }
  };

  // get MFA token
  static initiateMFA = async (token: string, source: string): Promise<any> => {
    try {
      const url = URlPREFIX + '/api/initiateMFA';
      const payload = {
        token,
        flow: source,
        mfa: sessionStorage.getItem('mfaToken'),
        bfp: sessionStorage.getItem('cvsbfp_v2')
      };
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'x-route': XROUTEHDR.gkeAndRke
        }
      });
      return await res.json();
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  //get details from campaignID
  static getCampaignInfo = async (campaignId: string): Promise<any> => {
    try {
      const url = URlPREFIX + '/api/getCampaignInfo';
      const payload = {
        campaignId
      };
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'x-route': XROUTEHDR.gkeAndRke
        }
      });
      return await res.json();
    } catch (err) {
      console.log(err);
      return err;
    }
  };
}
